export default __webpack_public_path__ + "static/media/uploadgallery.7606fd7c.svg";